import React from "react";
import "./OurServices.css";
import interior from "../../../assets/thumbnails/interior.jpg";
import homeConstuction from "../../../assets/thumbnails/home-construction.jpg";
import commercialProject from "../../../assets/thumbnails/commercial-service.jpg";
import consultancyService from "../../../assets/thumbnails/planning.jpg";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SHOW_PUBLIC_PROJECTS } from "../publicVisibility";

const servicesList = [
  {
    title: "Consultancy services",
    description:
      "We offer architectural plans, permission drawings, Vastu layouts, and expert guidance to help you start your construction the right way.",
    image: consultancyService,
  },
  {
    title: "Residential Construction",
    description:
      "Build your dream home from the ground up with expert planning, quality materials, and flawless execution tailored to your preferences.",
    image: homeConstuction,
  },
  {
    title: "Commercial Projects",
    description:
      "Build smart and modern commercial spaces that support business growth, with strong planning, trusted materials, and high-quality construction from start to finish.",
    image: commercialProject,
  },
  {
    title: "Interior Designing",
    description:
      "Elevate your interiors with stylish and functional designs that blend aesthetics with practicality, reflecting your unique personality.",
    image: interior,
  },
];

export default function OurServices() {
  return (
    <div className="services-wrapper">
      <h2 className="services-main-title mb-3">What we do?</h2>

      <div className="our-services-heading-container">
        <h1 className="services-headline">End To End Construction Solutions</h1>
        <p>
          We are specialized in a wide range of construction services, including
          residential, commercial, and interior projects.
        </p>
      </div>

      <div className="services-grid">
        {servicesList.map((item, index) => (
          <div className="single-service-card" key={index}>
            <div className="service-image-box">
              <img loading="lazy" decoding="async"
                src={item.image}
                className="service-image "
                alt={item.title}
              />
            </div>

            <div className="our-service-text-area">
              <h3 className="our-service-title">{item.title}</h3>
              <p className="service-description">{item.description}</p>
            </div>

            {SHOW_PUBLIC_PROJECTS && <div className="projects-btn">
              <Link to={"/projects"}> see our works</Link>
            </div>}
          </div>
        ))}
      </div>
    </div>
  );
}
